import { createFileRoute } from '@tanstack/react-router';

import { coinOrdersInfiniteQueryOptions } from '@/features/coins/api';
import { ChargeHistoryPage } from '@/features/coins/components/charge-history-page';

export const Route = createFileRoute('/_app/_auth/history')({
  staticData: { title: '충전 내역' },
  loader: ({ context }) => context.queryClient.infiniteQuery(coinOrdersInfiniteQueryOptions()),
  head: () => ({ meta: [{ title: '충전 내역 · 팬즈드롭 코인 충전' }] }),
  component: ChargeHistoryPage,
});
